(function ($, window, document) {
	var $win = $(window);
	var $doc = $(document);

	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}

	initMap = function() {
		var $mapSection	= $('.section--map'),
			$mapEl		= $mapSection.find('.map'),
			$mapControls	= $mapSection.find('.section--map__controls');

		if ($mapEl.length > 0) {
			var latLng = new google.maps.LatLng($mapEl.data('lat'), $mapEl.data('lng')),
				style = [{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#dadada"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]}];

			var mapOptions = {
				zoom: $mapEl.data('zoom'),
				center: latLng,
				draggable: true,
				zoomControl: false,
				scrollwheel: false,
				disableDefaultUI: true,
				styles: style
			}

			var map = new google.maps.Map($mapEl[0], mapOptions);

			var marker = new google.maps.Marker({
				position: latLng,
				icon: {
					url: main_theme.template_url + '/assets/dist/images/map-marker.svg',
					scaledSize: new google.maps.Size(68, 98),
				},
				map: map
			});

			var markerLink = $mapEl.data('url');

			if (markerLink !== '') {
				// marker.setTitle('View in Google Maps');

				marker.addListener('click', function() {
					window.open(markerLink, '_blank', 'noopener,noreferrer');
				});
			}

			if ($mapControls.length > 0) {
				var $zoomIn  = $mapControls.find('.map-zoom-in'),
					$zoomOut = $mapControls.find('.map-zoom-out');

				if ($zoomIn.length > 0) {
					google.maps.event.addDomListener($zoomIn[0], 'click', function() {
						map.setZoom(map.getZoom() + 1);
					});
				}

				if ($zoomOut.length > 0) {
					google.maps.event.addDomListener($zoomOut[0], 'click', function() {
						map.setZoom(map.getZoom() - 1);
					});
				}
			}
		}
	}

	function slick_init() {
		$('.section--hero-slider').slick({
			slide: '.section--hero__image',
			infinite: true,
			arrows: false,
			autoplay: true,
		});
	}

	$doc.on('ready', function() {
		slick_init();
	});
})(jQuery, window, document);
